import {Component, OnInit, ViewChild} from '@angular/core';
import {ApDynComponentComponent}      from '../../ap-dyncomponent/ap-dyncomponent.component';
import {ApDynGridColumnConfigBase}    from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {ApDynGridEditColumnConfig}    from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  ApNutrientPlanningComponent
}                                     from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning.component';
import {FormStore}                    from '../../stores/layout/form.store';
import {
  PlanningEntryComponentDataType
}                                     from '../../entry-components/ap-nutrients-management-entry-components/ap-nutrient-planning-configs/nutrient-planning-types';

@Component({
  selector: 'ap-nutrient-p-need',
  template: `
    <ap-dyncomponent [caption]="'Global__P_Need'"
                     [canCreate]="true"
                     [headerIcon]="'ap-icon-base-fertilization'"
                     [columns]="columns"
                     (create)="onCreate()">
    </ap-dyncomponent>
  `,
  styles: []
})
export class ApNutrientPNeedComponent implements OnInit {
  @ViewChild(ApDynComponentComponent) dynComponent;
  columns: ApDynGridColumnConfigBase[] = [];

  constructor(private formStore: FormStore) {
  }

  ngOnInit(): void {
    this.gridBuilder();
  }

  gridBuilder(): void {
    this.columns = [
      new ApDynGridEditColumnConfig(
        {
          disabled: true
        }
      )
    ];
  }

  public onCreate(): void {
    this.formStore.openForm({
      component: ApNutrientPlanningComponent,
      data: {
        Summary: null,
        Type: PlanningEntryComponentDataType.Create
      }
    });
  }
}
